import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import clsx from 'clsx';
import React, { useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Editor from '@/src/components/common/Files/Editor/Editor';
import { showToast } from '@/src/globalFunction';
import { addCommentFromApi } from '@/src/reducers/project/comments/comments.actions.js';
import { isMessageEmpty } from '@/src/util/conversations';

const Form = ({ onReplying, handleSelected, replyTo, textEditorClasses = '' }) => {
  const [comment, setComment] = useState('');
  const [, setIsFocused] = useState(false);
  const files = useSelector((state) => state.files);
  const onAddComment = useSelector((state) => state.comments.onAddComment);
  const dispatch = useDispatch();

  const handleSubmit = useCallback(() => {
    dispatch(addCommentFromApi(comment, replyTo)).then((response) => {
      if (response) {
        showToast('success', 'Comment has been added.');
        setComment('');

        if (onReplying) {
          onReplying(null);
        }

        if (handleSelected) {
          handleSelected({ id: null, type: null });
        }

        if (onAddComment) {
          onAddComment(response);
        }
      }
    });
  }, [comment, dispatch, handleSelected, onAddComment, onReplying, replyTo]);

  const handleInputChange = useCallback((value) => {
    setComment(value);
  }, []);

  const handleBlur = useCallback(() => {
    setIsFocused(false);
  }, []);

  const actionType = replyTo ? 'reply' : 'add';
  const fileComment = files.Actions[replyTo ? 'reply' : 'add']
    ? files.Actions[actionType].comment
    : '';
  const isEnabled = isMessageEmpty(fileComment) > 0;

  return (
    <div
      className={clsx('sendCommentContainer', replyTo && 'replyFormContainer', textEditorClasses)}
    >
      <ClickAwayListener onClickAway={handleBlur}>
        <div className={clsx('form-group mention', '!tw-m-0')}>
          <Editor
            classes={`fileComments ${replyTo ? 'reply' : 'add'}`}
            type={replyTo ? 'reply' : 'add'}
            submit={handleSubmit}
            isEnabled={isEnabled}
            handleChange={handleInputChange}
          />
        </div>
      </ClickAwayListener>
    </div>
  );
};
export default Form;
